/**
 * Clears the text selection on screen.
 */
export function clearSelection() {
  var _window;

  if ((_window = window) == null ? void 0 : _window.getSelection) {
    var _window2;

    var selection = (_window2 = window) == null ? void 0 : _window2.getSelection();

    if (!selection) {
      return;
    }

    if (selection.empty) {
      // Chrome
      selection.empty();
    } else if (selection.removeAllRanges) {
      // Firefox
      selection.removeAllRanges();
    } // @ts-ignore IE specific property

  } else if (document.selection) {
    // @ts-ignore IE specific property
    document.selection.empty();
  }
}